import { useState } from 'react';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import Dompurify from 'dompurify';

import { NOTICE_LIST_DATA } from '@lib/DUMMY';

import { Wrapper, EditorContents } from '@components/styled/StyledComponents';
import { InfoSection } from '@components/share/Info/InfoSection';
import Headline from '@components/layout/Headline';
import Loader from '@components/share/Loader';

const NoticeDetail = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);

    if (loading) return <Loader />;
    return (
        <Wrapper>
            <Headline
                title={NOTICE_LIST_DATA[+(id as string) - 1].title}
                subTitle={dayjs(
                    NOTICE_LIST_DATA[+(id as string) - 1].createdAt
                ).format('YYYY.MM.DD HH:mm')}
                GO_BACK
            />
            <InfoSection>
                <EditorContents
                    dangerouslySetInnerHTML={{
                        __html: Dompurify.sanitize(
                            NOTICE_LIST_DATA[+(id as string) - 1].title || ''
                        )
                    }}
                />
            </InfoSection>
        </Wrapper>
    );
};

export default NoticeDetail;
